<template>
  <!-- ╔═══════════════════════════════════════════╗
       ║     SECTION 6 : NOS DIFFÉRENTS MODÈLES    ║
       ╚═══════════════════════════════════════════╝ -->
  <section id="balises" class="py-10 py-sm-16">
    <v-container>
      <!-- TITRE ET TEXTE D'INTRODUCTION -->
      <v-row justify="center" class="text-center mb-12">
        <v-col cols="12" md="10">
          <h2
            :class="[
              'font-weight-bold mb-6',
              $vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
            ]"
          >
            {{ $t("section_6_our_balises_title") }}
          </h2>
          <p
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h6',
              'font-weight-light text-left',
            ]"
          >
            {{ $t("section_6_our_balises_text") }}
          </p>
        </v-col>
      </v-row>

      <!-- LES CARDS PRODUITS -->
      <v-row justify="center">
        <baliseCard
          v-for="(balise, i) in balises"
          :key="i"
          :title="balise.title"
          :image="balise.image"
          :price="balise.price"
          :url="balise.url"
        />
      </v-row>

      <!-- BOUTON DE REDIRECTION BOUTIQUE -->
      <v-row justify="center" class="mt-12">
        <v-btn
          large
          depressed
          color="primary"
          class="px-10"
          href="https://mabalise.be/shop/#wais"
          target="_blank"
        >
          {{ $t("section_6_btn") }}
        </v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<!-- ╔═════════════════╗
     ║     SCRIPTS     ║
     ╚═════════════════╝ -->

<script>
import Vue from "vue";
import baliseCard from "@/components/cards/card_2.vue";

export default Vue.extend({
  name: "ourBeacons-section",

  components: {
    baliseCard,
  },

  computed: {
    balises() {
      return [
        {
          title: this.$t("section_6_card_1_title"),
          image: require("@/assets/bracelet.png"),
          price: this.$t("section_6_card_1_price"),
          tva_text: this.$t("section_6_tva_text"),
          url: "https://mabalise.be/shop/bracelet-wais/#product-1846",
        },
        {
          title: this.$t("section_6_card_2_title"),
          image: require("@/assets/carte.png"),
          price: this.$t("section_6_card_2_price"),
          tva_text: this.$t("section_6_tva_text"),
          url: "https://mabalise.be/shop/carte-wais/#product-1840",
        },
        {
          title: this.$t("section_6_card_3_title"),
          image: require("@/assets/porte_cle.png"),
          price: this.$t("section_6_card_3_price"),
          tva_text: this.$t("section_6_tva_text"),
          url: "https://mabalise.be/shop/porte-cle-wais/#product-1853",
        },
      ];
    },
  },
});
</script>
